import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {TxnTemplateDto} from "../../model/TxnTemplateDto";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;
import * as angular from "angular";
import {IComponentController, IScope} from "angular";
import {DebounceFactory} from "../../modules/DebounceModule";
import {DisposeBag} from "../../modules/DisposeBag";

class ListComponentController implements IComponentController {
    private disposeBag = new DisposeBag();
    private templates: TxnTemplateDto[] = [];
    private customerGuid: string;
    private filter: string;

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reloadDebounce();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }
    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService,
                private $localStorage: StorageService,
                private $debounce: DebounceFactory,
                private $scope: IScope,
                private $state: StateService,
                private $stateParams: any) {
        $dataHub.bindAllTxnTemplate(() => this.templates, this.disposeBag);
        $dataHub.onConnected(this.reloadDebounce, this.disposeBag);
    }


    reload = () => {
        console.debug('listComponent refresh', this.customerGuid);
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.txnTemplateSubscribe(this.customerGuid)
            .catch(this.$dataHub.defaultErrorHandler);
    };

    reloadDebounce = this.$debounce(this.reload, 1000, false);


    get orderBy() {
        return this.$localStorage.txnTemplateListControllerOrderBy || 'customer.fullName';
    }

    set orderBy(value) {
        this.$localStorage.txnTemplateListControllerOrderBy = value;
    }

}

export default angular.module('app.txnTemplate.listComponent', [])
    .component('txnTemplateList', {
        template: require('./ListComponent.html'),
        controller: ListComponentController,
        controllerAs: 'vm',
        bindings: {
            customerGuid: '=',
            popout: '=',
            filter: '=',
            filterActive: '=',
            filterReview: '='
        }
    }).name;
